import React from 'react'
import { Typography, Stack, Box, Grid, Divider, InputLabel, Button, Checkbox, TextField } from '@mui/material'
import BreakFormIcon from "../../../../Icons/Account/BreakForm.svg"


export default function AdminApproval({ setStepperCount }) {
    return (
        <Box px={{ md: 10, xs: 3 }}>
            <Typography variant="h6_1">Admin approval</Typography>
            <Grid mt={3} mb={6} container rowGap={7}>
                <Grid xs={12} sx={{ display: "flex", flexDirection: "column" }} rowGap={2} gap={2}>
                    <Divider />
                    <Stack my={10} direction="column" justifyContent="space-between" alignItems="center" gap={1}>
                        <Box mb={3} component="img" src={BreakFormIcon}></Box>
                        <Typography variant="h6_1">Break contract requested</Typography>
                        <Typography variant='h7_2' >Please wait for the confirmation email by vinga admin in your inbox</Typography>
                        <Button sx={{ mt: 3 }} variant="standard" onClick={() => { setStepperCount(3) }}>Go to Dashboard</Button>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}
